export {};
declare global {
    interface Date {
        compare(value: Date | undefined): number;
        compareDate(value: Date | undefined): number;
        dateOnly(): Date;
        equalsDate(value: Date | undefined): boolean;
        secondsBetween(value: Date): number;
        toDate(): Date;
        toLocaleLong(): string;
        toLocaleShortTime(): string;
    }
}

if (!Date.prototype.compare) {
    Date.prototype.compare = function compare(
        this: Date,
        value: Date | undefined,
    ): number {
        return this.getTime() < (value?.getTime() ?? 0)
            ? -1
            : this.getTime() === value?.getTime()
              ? 0
              : 1;
    };
}

if (!Date.prototype.compareDate) {
    Date.prototype.compareDate = function compareDate(
        this: Date,
        value: Date | undefined,
    ): number {
        return this.dateOnly().compare(value?.dateOnly());
    };
}

if (!Date.prototype.dateOnly) {
    Date.prototype.dateOnly = function dateOnly(this: Date): Date {
        return new Date(
            this.getFullYear(),
            this.getMonth(),
            this.getDate(),
            0,
            0,
            0,
        );
    };
}

if (!Date.prototype.equalsDate) {
    Date.prototype.equalsDate = function equalsDate(
        this: Date,
        value: Date | undefined,
    ): boolean {
        return this.compareDate(value) == 0;
    };
}

if (!Date.prototype.secondsBetween) {
    Date.prototype.secondsBetween = function secondsBetween(
        this: Date,
        value: Date,
    ): number {
        return (this.getTime() - value.getTime()) / 1000;
    };
}

if (!Date.prototype.toDate) {
    Date.prototype.toDate = function toDate(this: Date): Date {
        return this;
    };
}

if (!Date.prototype.toLocaleLong) {
    Date.prototype.toLocaleLong = function toLocaleLong(this: Date): string {
        return (
            this.toLocaleDateString(navigator.language, {
                dateStyle: "long",
            } as Intl.DateTimeFormatOptions) +
            " " +
            this.toLocaleTimeString(navigator.language, {
                timeStyle: "short",
            } as Intl.DateTimeFormatOptions)
        );
    };
}

if (!Date.prototype.toLocaleShortTime) {
    Date.prototype.toLocaleShortTime = function toLocaleShortTime(
        this: Date,
    ): string {
        return this.toLocaleTimeString(navigator.language, {
            timeStyle: "short",
        } as Intl.DateTimeFormatOptions);
    };
}
